import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios"; import { Alert, Form, Input, message } from "antd";
import { hideLoading, showLoading, ReloadFalse } from "../redux/rootSlice";
import { useNavigate } from "react-router-dom"; // Import useHistory from react-router-dom


const AdminLogin = () => {
    const [form] = Form.useForm();
    const [showPassword, setShowPassword] = useState(false);
    const dispatch = useDispatch();
    const { setUserData, errorAlert } = useSelector((state) => state.root);
    const navigate = useNavigate();



    const getUserData = async (value) => {
        try {
            dispatch(showLoading());
            const response = await axios.post("https://backendz182.up.railway.app/api/Auth/login", value);
            dispatch(hideLoading());
            console.log("Response Status:", response.status); // Log the response status

            if (response.data.success) {
                //   message.success("Redirecting To Admin Panel");
                message.success(response.data.message);
                localStorage.setItem("token", response.data.token);
                dispatch(showLoading());
                navigate("/admin");
                dispatch(ReloadFalse());
                dispatch(hideLoading());
            } else {

                message.error(response.data.message);
                form.resetFields();
            }

        } catch (error) {
            console.error(error);
            dispatch(hideLoading());
            form.resetFields();
            message.warning("Unauthorized access. Please check your credentials.");
        }
    };

    const onFinish = (values) => {

        getUserData(values)
    };


    const handleTogglePassword = () => {
        setShowPassword(!showPassword);
    };
    useEffect(() => {
        if (localStorage.getItem("token") !== null) {
            message.warning("Already Login.");
            navigate("/admin");
        }

    }, []);


    return (
        <>
            {errorAlert && (
                <Alert message="Error! Invalid Details" type="error" showIcon />
            )}
            <div>
                <div className="flex flex-col items-center justify-center login-form">
                    <div className="flex flex-col lg:w-[30dvw] md:w-[60dvw] sm:w-[90dvw] px-8 py-6  login gap-3">
                        <p className=" font-black  text-3xl"> Login</p>
                        <Form
                            onFinish={onFinish}
                            layout="vertical"

                            form={form}>
                            <Form.Item
                                label="Email"
                                name="email"
                                className="font-semibold login-input "
                                rules={[
                                    { required: true, message: "Please enter the Email Addres." },
                                ]}>
                                <Input
                                    className=" h-[40px]"
                                    placeholder="Email Address/Username"
                                />
                            </Form.Item>
                            <Form.Item
                                label="Password"
                                name="password"
                                className="font-semibold login-input "
                                rules={[
                                    {
                                        required: true,
                                        message: "Please input your password!",
                                    },
                                ]}>
                                <Input.Password
                                    className=" h-[40px]"
                                    placeholder="Enter Password"
                                />
                            </Form.Item>

                            <div className="flex  justify-end me-1">
                                <button
                                    type="submit"
                                    className="button border p-2 px-5 rounded border-outline border-primary bg-primary text-tertiary font-medium hover:bg-secondary hover:border-secondary hover:text-tertiary hover:font-semibold ease-in-out"
                                    disabled={
                                        form.isFieldsTouched(true) &&
                                        form.getFieldsError().filter(({ errors }) => errors.length)
                                            .length > 0
                                    }>
                                    Login
                                </button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AdminLogin;
